import { create } from "zustand";
import { persist } from "zustand/middleware";
import { TOperationData } from "../types/operation";

interface OperationStore {
	operation: TOperationData | null;
	setOperation: (operation: TOperationData) => void;
}

export const useOperationStore = create<OperationStore>()(
	persist(
		(set) => ({
			operation: null,
			setOperation: (operation: TOperationData) => set({ operation }),
		}),
		{
			name: "operation-store",
		}
	)
);
